import { HttpService } from "@/core";
import {
  WorkOrderPageReq,
  WorkOrderPageResp,
  WorkOrderDetailResp,
  WorkOrderReq,
  WorkOrderSimpleListResp,
} from "./workOrder.interface";

export class WorkOrderService {
  static usePageApi() {
    const api = (params: WorkOrderPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/maintenance_ticket_type/page",
        params,
      });
    return HttpService.usePagination<WorkOrderPageResp>(api);
  }
  static useImportApi() {
    const api = (url: string) =>
      HttpService.axios({
        method: "POST",
        url: `/maintenance_ticket_type/import`,
        data: {
          url,
        },
      });
    return HttpService.useRequest<void>(api);
  }
  static useSimpleListApi() {
    const api = (data={}) =>
      HttpService.axios({
        method: "POST",
        url: "/maintenance_ticket_type/list",
        data
      });
    return HttpService.useRequest<WorkOrderSimpleListResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/maintenance_ticket_type/${id}`,
      });
    return HttpService.useRequest<WorkOrderDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: WorkOrderReq) =>
      HttpService.axios({
        method: "POST",
        url: "/maintenance_ticket_type",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data: WorkOrderReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/maintenance_ticket_type/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/maintenance_ticket_type/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useUploadUnit() {
    const api = (url) =>
      HttpService.axios({
        url: "/maintenance_ticket_type/settleUnit/importBatchCheck",
        data: {
          url,
        },
        method: "post",
      });
    return HttpService.useRequest<any>(api);
  }

  static useFinishUpload() {
    const api = (data) =>
      HttpService.axios({
        url: "/maintenance_ticket_type/settleUnit/importBatchAdd",
        data: {
          unitTypeReqs: data,
        },
        method: "post",
      });
    return HttpService.useRequest<void>(api);
  }
}
